import { IasProduct, IasOther } from "./ias"
import { q, qq } from "../../helper/q"

export const searchInit = () => {
  const product = q(".searchProductsGroup")
  const other = q(".searchOthersGroup")
  if (product || other) {
    const iasProduct = new IasProduct(product)
    const iasOther = new IasOther(other)
    other
    iasProduct.init()
    iasOther.init()
  }
}
